import css from './BusinessSection.module.css';
import {
  Badge,
  Box,
  Button,
  Center,
  Container,
  GridItem,
  Heading,
  HStack,
  Icon,
  Image,
  LinkBox,
  LinkOverlay,
  SimpleGrid,
  Text,
} from '@chakra-ui/react';
import RocketLaunchRoundedIcon from '@mui/icons-material/RocketLaunchRounded';
import MoreTimeRoundedIcon from '@mui/icons-material/MoreTimeRounded';
import PeopleRoundedIcon from '@mui/icons-material/PeopleRounded';
import LeaderboardRoundedIcon from '@mui/icons-material/LeaderboardRounded';
import TrendingUpRoundedIcon from '@mui/icons-material/TrendingUpRounded';

import classnames from 'classnames';

const BusinessSection = () => {
  const businessFeaturesList = [
    {
      title: 'Save time',
      desc:
        'No more trying to beat the algorithm — create your page in minutes and let customers find you through a clean, stylish UI.',
      icon: <MoreTimeRoundedIcon />,
    },
    {
      title: 'Reach more members',
      desc:
        'Potential leads can DM you in seconds, explore your website, and check out your socials — all in one seamless flow.',
      icon: <PeopleRoundedIcon />,
    },
    {
      title: 'Boost visibility',
      desc: 'You’re not just listed — you’re discovered by people searching for anything fitness.',
      icon: <TrendingUpRoundedIcon />,
    },
    {
      title: 'Analytics & insights',
      desc: 'Track your profile performance and understand what members are looking for.',
      icon: <LeaderboardRoundedIcon />,
    },
  ];

  return (
    <section id="business" className={classnames(css.businessSection, css.background)}>
      <Container maxW={'5xl'} className={css.container}>
        <SimpleGrid columns={{ base: 1, md: 6 }} gap="3rem" align={'center'} justify={'center'}>
          <GridItem colSpan={{ base: 1, md: 4 }}>
            <Badge size="md" colorPalette="purple" variant="surface">
              For Business
            </Badge>
            <Heading
              size={{
                base: '3xl',
                lg: '5xl',
              }}
              color={'white'}
              fontWeight={'bold'}
            >
              You build your business,
              <br />
              we bring it all together
            </Heading>
            <Text
              fontSize={{
                base: 'md',
                lg: 'lg',
              }}
              fontWeight="medium"
              color={'white'}
              styles={{ mb: '3rem' }}
            >
              <span className={css.footfallLogo}>FootFall</span> is the only discovery platform
              unifying fitness classes, trainers, gyms, and sports clubs — unlocking cross-category
              demand.
            </Text>
            <div>
              <SimpleGrid rowGap={'0.8rem'}>
                {businessFeaturesList.map((feature, idx) => (
                  <div key={idx} className={css.featuresList}>
                    <div>
                      <Box p="1em" bg="brand.50" borderRadius="1em" display="inline-block">
                        <Icon size="xl" color={'brand.900'} boxSize="1em">
                          {feature.icon}
                        </Icon>
                      </Box>
                    </div>
                    <div>
                      <Heading
                        size={{
                          base: 'sm',
                          lg: 'md',
                        }}
                        fontWeight={'bold'}
                        color={'white'}
                        as={'h4'}
                        mt={0}
                        mb={0}
                      >
                        {feature.title}
                      </Heading>
                      <Text
                        fontSize={{
                          base: 'sm',
                          lg: 'md',
                        }}
                        mt={0}
                        mb={0}
                        color={'white'}
                      >
                        {feature.desc}
                      </Text>
                    </div>
                  </div>
                ))}
              </SimpleGrid>
              <HStack mt={'2rem'} gap={'1rem'}>
                <LinkBox>
                  <LinkOverlay href={'/signup'}>
                    <Button variant="surface" colorPalette={'gray'}>
                      <Icon color={'brand.600'}>
                        <RocketLaunchRoundedIcon />
                      </Icon>{' '}
                      List your business
                    </Button>
                  </LinkOverlay>
                </LinkBox>
                <LinkBox>
                  <LinkOverlay href={'/p/for-business'}>
                    <Button variant="outline" color={'white'}>
                      Learn more
                    </Button>
                  </LinkOverlay>
                </LinkBox>
              </HStack>
            </div>
          </GridItem>
          <GridItem colSpan={{ base: 1, md: 2 }}>
            <Center h="100%">
              <Image
                src={
                  'https://res.cloudinary.com/dtknri7vc/image/upload/v1765551613/football_transparent_lxtn8u.png'
                }
              />
            </Center>
          </GridItem>
        </SimpleGrid>
      </Container>
    </section>
  );
};

export default BusinessSection;
